import * as React from "react";
import { SVGProps } from "react";

const CardIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <g id="Card payment">
      <g id="Vector">
        <path
          d="M42.6047 18.8887H5.39535C4.63256 18.8887 4 18.2561 4 17.4933C4 16.7306 4.63256 16.098 5.39535 16.098H42.6047C43.3674 16.098 44 16.7306 44 17.4933C44 18.2561 43.3674 18.8887 42.6047 18.8887Z"
          fill="#1A1C1F"
          className={props.className}
        />
        <path
          d="M16.5582 33.7644H12.8372C12.0745 33.7644 11.4419 33.1319 11.4419 32.3691C11.4419 31.6063 12.0745 30.9737 12.8372 30.9737H16.5582C17.321 30.9737 17.9535 31.6063 17.9535 32.3691C17.9535 33.1319 17.321 33.7644 16.5582 33.7644Z"
          fill="#1A1C1F"
          className={props.className}
        />
        <path
          d="M28.6512 33.7644H21.2093C20.4465 33.7644 19.814 33.1319 19.814 32.3691C19.814 31.6063 20.4465 30.9737 21.2093 30.9737H28.6512C29.414 30.9737 30.0465 31.6063 30.0465 32.3691C30.0465 33.1319 29.414 33.7644 28.6512 33.7644Z"
          fill="#1A1C1F"
          className={props.className}
        />
        <path
          d="M34.3442 41.2008H13.6558C6.25116 41.2008 4 38.9694 4 31.6432V16.3584C4 9.03213 6.25116 6.80078 13.6558 6.80078H34.3256C41.7302 6.80078 43.9814 9.03213 43.9814 16.3584V31.6246C44 38.9694 41.7488 41.2008 34.3442 41.2008ZM13.6558 9.58997C7.81395 9.58997 6.7907 10.5941 6.7907 16.3584V31.6246C6.7907 37.3889 7.81395 38.393 13.6558 38.393H34.3256C40.1674 38.393 41.1907 37.3889 41.1907 31.6246V16.3584C41.1907 10.5941 40.1674 9.58997 34.3256 9.58997H13.6558Z"
          fill="#1A1C1F"
          className={props.className}
        />
      </g>
    </g>
  </svg>
);

export default CardIcon;
